module.exports = __webpack_public_path__ + "img/3.12fe679a.png";